import ApiService from '@/services/ApiService';

class IntercomService {
  static async getIntercomData() {
    const composedURL = `/api3/core/intercom`;
    const response = await ApiService.get(composedURL);
    return response;
  }
}

export default IntercomService;
